import customDropdown from '@/components/dropdown/customDropdown.vue'
import { BTable, BBadge } from 'bootstrap-vue'
import * as moment from 'moment'
import debounce from 'lodash/debounce'
import SkeletonLoaderVue from 'skeleton-loader-vue'

export default {
  components: {
    customDropdown,
    BTable,
    BBadge,
    SkeletonLoaderVue,
  },
  data() {
    return {
      currentPage: (this.$route.query?.page && Number(this.$route.query.page)) || 1,
      month: moment().format('MM'),
      year: moment().format('YYYY'),
      totalCount: 0,
      perPage: this.$route.query.per_page || 100,
      sortBy: null,
      sortDesc: 'desc',
      stickyHeader: true,
      noCollapse: false,
      userSkills: [],
      primarySkills: [],
      secondarySkills: [],
      reporting_to_users: [],
      manage_by_users: [],
      reporting_to: null,
      manage_by: null,
      loading: true,
      search: null,
      is_active: 'active',
      isPoolList: [
        { label: 'All', value: 'all' },
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
      is_pool: 'all',
      fields: [
        { key: 'full_name', label: 'Name', thClass: 'teamName', tdClass: 'teamName' },
        { key: 'manage_by', label: 'Managed By', thClass: 'teamName', tdClass: 'teamName' },
        { key: 'reporting_to', label: 'Reporting To', thClass: 'teamName', tdClass: 'teamName' },
        { key: 'primary_skill', label: 'Primary Skill(s)', tdClass: 'teamPrimary' },
        { key: 'secondary_skill', label: 'Secondary Skill(s)', tdClass: 'teamSecondary' },
        { key: 'department', label: 'Department', tdClass: 'teamPrimary' },
        { key: 'division', label: 'Division', tdClass: 'teamPrimary' },
        { key: 'designation', label: 'Designation', tdClass: 'teamPrimary' },
        { key: 'file_name', label: 'File Name', tdClass: 'productivity' },
        { key: 'resume_description', label: 'Resume Description', tdClass: 'productivity', maxWidth: '10px' },
        { key: 'resume_link', label: 'Resume Link', tdClass: 'productivity', thStyle: { minWidth: '130px', textAlign: 'start' } },
        { key: 'resume_file', label: 'Resume File', tdClass: 'productivity', thStyle: { minWidth: '130px', textAlign: 'start' } },
      ],
      items: [],
      skillCondition: 'AND',
      pageIndex: 0,
      isGetTotalUserCount: false,
      isActivityLoader: false,
    }
  },
  computed: {
    queryData() {
      return {
        is_active: this.is_active,
        page: this.currentPage,
        per_page: this.perPage,
        reporting_to: this.reporting_to,
        manage_by: this.manage_by,
        primarySkills: this.primarySkills || [],
        secondarySkills: this.secondarySkills || [],
        month: this.month,
        year: this.year,
        search: this.search,
        skillCondition: this.skillCondition,
        pageIndex: this.pageIndex,
        is_pool: this.is_pool,
        main_page: 'resumes',
      }
    },
    debouncedSearch: {
      get() {
        return this.search
      },
      set: debounce(function (value) {
        this.search = value
        this.ResumeData()
      }, 500),
    },
  },
  watch: {
    currentPage(value) {
      if (value) this.ResumeData()
    },
    perPage() {
      if (this.currentPage === 1) this.ResumeData()
      else this.currentPage = 1
    },
  },
  mounted() {
    if (Object.keys(this.$route.query).length > 0) this.setFilterValue()
    this.filterFunctionCallFromMixin()

    if (this.userInfo?.role === 'EMP') this.manage_by = this.userInfo.id
    this.ResumeData()
  },
  methods: {
    setFilterValue() {
      const query = this.$route.query || {}
      this.is_active = query.is_active ?? this.is_active
      this.perPage = query.perPage ?? this.perPage
      this.currentPage = Number(query.page) ?? this.currentPage
      this.reporting_to = query.reporting_to ?? this.reporting_to
      this.manage_by = query.manage_by ?? this.manage_by
      this.skillCondition = query.skillCondition ?? this.skillCondition
      this.secondarySkills = Array.isArray(query.secondarySkills) ? query.secondarySkills : query.secondarySkills ? [query.secondarySkills] : this.secondarySkills
      this.primarySkills = Array.isArray(query.primarySkills) ? query.primarySkills : query.primarySkills ? [query.primarySkills] : this.primarySkills
      this.month = query.month ?? this.month
      this.year = query.year ?? this.year
      this.search = query.search ?? this.search
      this.pageIndex = query.pageIndex ?? this.pageIndex
      this.is_pool = query.is_pool ?? this.is_pool
    },

    async filterFunctionCallFromMixin() {
      if (this.userInfo?.role === 'SA' && this.$store.state.app.groupList.length === 0) {
        this.groups = await this.getGroupData()
      } else {
        this.groups = this.$store.state.app.groupList
      }

      this.manage_by_users = this.$store.state.app.manageByUsersList.length ? this.$store.state.app.manageByUsersList : await this.manageByUserList()
      this.reporting_to_users = this.$store.state.app.reportingUserList.length ? this.$store.state.app.reportingUserList : await this.reportingtoUserList()
      this.userSkills = this.$store.state.app.userSkills.length ? this.$store.state.app.userSkills : await this.getPrimarySkillData()
    },

    userSummary(id) {
      this.pageIndex = window.scrollY
      this.$router.push({ name: 'MyTeamDetails', params: { id }, query: this.queryData })
    },

    clearFilter() {
      this.primarySkills = []
      this.secondarySkills = []
      this.manage_by = this.userInfo?.role === 'EMP' ? this.userInfo.id : null
      this.reporting_to = null
      this.currentPage = 1
      this.search = null
      this.perPage = 100
      this.month = moment().format('MM')
      this.year = moment().format('YYYY')
      this.is_active = 'active'
      this.skillCondition = 'AND'
      this.pageIndex = 0
      this.is_pool = 'all'
      this.ResumeData()
    },

    ResumeData() {
      const input = this.commonPayloadObject()
      this.routeQueryUpdate(this.queryData)
      this.fetchResumeData(input)
    },

    commonPayloadObject() {
      return {
        is_active: this.is_active !== 'all_data' ? (this.is_active === 'active') : '',
        page: this.currentPage,
        per_page: this.perPage,
        sort_field: this.sortBy,
        sort_order: this.sortDesc ? 'desc' : 'asc',
        reporting_to: this.reporting_to,
        manage_by: this.manage_by,
        primary_skill_ids: this.primarySkills || [],
        secondary_skill_ids: this.secondarySkills || [],
        month: this.month,
        year: this.year,
        search: this.search,
        skill_condition: this.skillCondition,
        is_pool: this.is_pool !== 'all' ? this.is_pool === 'yes' : null,
      }
    },

    async fetchResumeData(input) {
      this.loading = true
      const response = await this.getHTTPPostResponse('admin/master/resume/user-resume-list', input, false)
      if (response?.data) this.items = response.data.resumes
      this.totalCount = response.data?.count || 0
      this.loading = false
      this.isGetTotalUserCount = false
      this.$nextTick(() => (document.documentElement.scrollTop = this.pageIndex))
      setTimeout(() => (this.pageIndex = 0), 1000)
    },

    async downloadFile(data) {
      try {
        const URL = `${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_API_VERSION}/admin/master/resume/download?url=${data.item.url}`
        const response = await this.$axios({ url: URL, method: 'GET', params: { url: data.item.url }, responseType: 'blob' })
        const disposition = response.headers['content-disposition']
        let fileName = data.item.file_name
        if (disposition?.includes('filename=')) fileName = disposition.split('filename=')[1].replace(/"/g, '')
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        this.createDownloadLink(window.URL.createObjectURL(blob), fileName)
      } catch (error) {
        console.error('Error downloading file:', error)
      }
    },

    createDownloadLink(url, name) {
      const a = document.createElement('a')
      a.href = url
      a.download = name
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
  },
}
